import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { api } from "../../../software/api";
import { WifiOff } from "lucide-react";

const TERM_KEY = "anx_spin_terminal";
const HOURS = { 1: [510, 1050], 2: [510, 1050], 3: [510, 1050], 4: [510, 1050], 5: [510, 1050], 6: [540, 900] };

export const shopOpen = (d = new Date()) => {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-AU", { timeZone: "Australia/Sydney", weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(d).map((x) => [x.type, x.value]));
  const day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(p.weekday);
  const mins = Number(p.hour) * 60 + Number(p.minute);
  const h = HOURS[day];
  return !!h && mins >= h[0] && mins < h[1];
};

// Alerts THIS computer when its linked Spin tester drops offline (>2 min) during opening hours.
export function SpinOfflineWatcher() {
  const [alert, setAlert] = useState(null);
  const wasOnline = useRef(false);
  const shown = useRef(false);
  useEffect(() => {
    const check = async () => {
      const name = localStorage.getItem(TERM_KEY);
      if (!name || !shopOpen()) return;
      const t = (await api("GET", "/spin/terminals").catch(() => null) || []).find((x) => x.name === name);
      if (!t) return;
      const gone = (Date.now() - new Date(t.last_seen).getTime()) / 1000;
      if (t.online) { wasOnline.current = true; shown.current = false; setAlert(null); return; }
      if (wasOnline.current && gone > 120 && !shown.current) { shown.current = true; setAlert({ name, mins: Math.round(gone / 60) }); }
    };
    check(); const iv = setInterval(check, 30000);
    return () => clearInterval(iv);
  }, []);
  if (!alert) return null;
  return createPortal(
    <div className="fixed inset-0 z-[200] bg-black/50 flex items-center justify-center p-4" data-testid="spin-offline-alert">
      <div className="w-full max-w-md rounded-xl bg-white border-2 border-red-500 shadow-2xl overflow-hidden">
        <div className="flex items-center gap-2 bg-red-600 text-white px-4 py-2.5 font-black"><WifiOff className="h-5 w-5" />Spin Tester "{alert.name}" is Offline</div>
        <div className="p-4 text-[13px] text-slate-700 space-y-2">
          <p>This computer's Spin tester stopped responding about {alert.mins} min ago.</p>
          <ol className="list-decimal pl-5 space-y-1">
            <li>Check <b>WaterLink Connect</b> is open and the Spin Touch is plugged in.</li>
            <li>Double-click <b>Start Spin Bridge</b> on the Desktop.</li>
            <li>The light next to the Spin button turns green within a few seconds.</li>
          </ol>
          <button onClick={() => setAlert(null)} data-testid="spin-offline-alert-dismiss" className="w-full mt-2 rounded-full bg-[#123a63] text-white font-black py-2 hover:bg-[#1a4f8a]">OK</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
